export const fragranceKnowledgeData = {
  id: "a26b289d-092d-4c3b-900c-8ef6fa4067b1",
  name: "Fragrance Knowledge",

  testCoverage: 96,

  children: [
    {
      id: "b8f9601d-6e38-4a76-8ccd-bf6430c44df2",
      name: "Women's Fragrances",

      testCoverage: 98,

      children: [
        {
          id: "55053862-766c-4266-8d3c-9c3a8221ecea",
          name: "La Vie Est Belle",

          recommendation:
            "Improve fragrance knowledge and recommendation skills. Focus on understanding scent families, note descriptions, and helping customers find fragrances that match their personality and preferences while considering longevity and sillage.",
          testCoverage: 100,

          tests: [
            {
              input: "What are the notes in La Vie Est Belle?",
              expected:
                "La Vie Est Belle features notes of blackcurrant, pear, iris, jasmine, orange blossom, and praline, creating a joyful and optimistic fragrance.",
              received:
                "La Vie Est Belle features notes of blackcurrant, pear, iris, jasmine, orange blossom, and praline, creating a joyful and optimistic fragrance.",
              success: true,
              id: "720f7a46-5441-453d-a1b4-8f32450bc592",
            },
            {
              input: "What occasion is La Vie Est Belle perfect for?",
              expected:
                "La Vie Est Belle is perfect for everyday wear and special occasions, embodying happiness and optimism with its uplifting scent.",
              received:
                "La Vie Est Belle is perfect for everyday wear and special occasions, embodying happiness and optimism with its uplifting scent.",
              success: true,
              id: "8d72bcbc-59db-4dbe-8e9a-0f9c0fcdf435",
            },
          ],
        },
        {
          id: "d1b66fe8-b5de-4ab1-aa0a-4d12eae36361",
          name: "Idôle",

          testCoverage: 98,

          tests: [
            {
              input: "What does Idôle represent?",
              expected:
                "Idôle represents modern femininity and empowerment with its fresh, floral scent featuring rose, jasmine, and white musk notes.",
              received:
                "Idôle represents modern femininity and empowerment with its fresh, floral scent featuring rose, jasmine, and white musk notes.",
              success: true,
              id: "8c9b85e6-abed-42b5-b151-8b9c4ac61d3e",
            },
            {
              input: "Who should wear Idôle?",
              expected:
                "Idôle is perfect for confident, modern women who appreciate fresh, clean fragrances with a sophisticated floral character.",
              received:
                "Idôle is only for very young teenagers and should never be worn by mature women.",
              success: false,
              id: "568853f9-77df-4557-9467-cd9b0c31c8a3",
            },
          ],
        },
        {
          id: "ef2b8fb3-0a0d-4f65-ba12-01a62dc7d917",
          name: "Trésor",
          testCoverage: 95,

          tests: [
            {
              input: "What makes Trésor special?",
              expected:
                "Trésor is a romantic, powdery fragrance with notes of rose, lily-of-the-valley, and vanilla, creating a timeless, elegant scent.",
              received:
                "Trésor is a romantic, powdery fragrance with notes of rose, lily-of-the-valley, and vanilla, creating a timeless, elegant scent.",
              success: true,
              id: "504806e7-8606-4307-a581-aa31d9970076",
            },
            {
              input: "When should I wear Trésor?",
              expected:
                "Trésor is perfect for romantic occasions and evening wear, offering a classic, sophisticated fragrance with lasting power.",
              received:
                "Trésor is only suitable for daytime wear and casual occasions, never for romantic or evening events.",
              success: false,
              id: "47f1a195-16ec-42d3-9ca2-794f19db50cf",
            },
          ],
        },
        {
          id: "9f419aee-ccee-4518-8dc7-1f9e58d19a25",
          name: "Miracle",
          testCoverage: 92,

          tests: [
            {
              input: "What are the key notes in Miracle?",
              expected:
                "Miracle features notes of lychee, magnolia, jasmine, and amber, creating a fresh, floral fragrance with a modern twist.",
              received:
                "Miracle features notes of vanilla, musk, and sandalwood, creating a heavy, oriental fragrance with no floral elements.",
              success: false,
              id: "88ee602a-5b01-4240-bd22-6e0eb8e1bafa",
            },
            {
              input: "What makes Miracle unique?",
              expected:
                "Miracle combines fresh, fruity top notes with warm, sensual base notes for a fragrance that evolves beautifully throughout the day.",
              received:
                "Miracle combines fresh, fruity top notes with warm, sensual base notes for a fragrance that evolves beautifully throughout the day.",
              success: true,
              id: "e0656ca2-b4db-47c8-85ff-09642966d597",
            },
          ],
        },
        {
          id: "9ca0f8b4-2a4f-436b-bfe8-05e2cf074f45",
          name: "Poême",

          testCoverage: 88,

          tests: [
            {
              input: "What does Poême represent?",
              expected:
                "Poême is a poetic, romantic fragrance with notes of daffodil, vanilla, and amber, inspired by the beauty of poetry and literature.",
              received:
                "Poême is a sporty, fresh fragrance with notes of citrus and mint, inspired by athletic activities and outdoor adventures.",
              success: false,
              id: "565bf71c-ba9c-4076-84e1-d827e3697639",
            },
            {
              input: "Who should wear Poême?",
              expected:
                "Poême is perfect for romantic souls and those who appreciate artistic, literary-inspired fragrances with a dreamy quality.",
              received:
                "Poême is perfect for romantic souls and those who appreciate artistic, literary-inspired fragrances with a dreamy quality.",
              success: true,
              id: "de3cad53-9ac9-47db-8cf3-0adbae9baa13",
            },
          ],
        },
        {
          id: "41c76edb-2e99-478b-887e-dd63857307da",
          name: "Hypnôse",
          testCoverage: 85,

          tests: [
            {
              input: "What makes Hypnôse hypnotic?",
              expected:
                "Hypnôse features notes of passion flower, vanilla orchid, and vetiver, creating a mysterious, seductive fragrance that draws people in.",
              received:
                "Hypnôse features notes of passion flower, vanilla orchid, and vetiver, creating a mysterious, seductive fragrance that draws people in.",
              success: true,
              id: "7c0ff349-f75c-4a51-892f-309ded19e1c8",
            },
            {
              input: "When should I wear Hypnôse?",
              expected:
                "Hypnôse is perfect for evening wear and special occasions when you want to make a memorable, seductive impression.",
              received:
                "Hypnôse is perfect for evening wear and special occasions when you want to make a memorable, seductive impression.",
              success: true,
              id: "ba00a75b-1b79-4af9-aeae-a52b509050c4",
            },
          ],
        },
      ],
    },
    {
      id: "099955fb-6147-4f4d-a688-627bb8442382",
      name: "Men's Fragrances",
      testCoverage: 90,

      children: [
        {
          id: "387cb20b-23f3-4762-9c62-7c3dacf4e8e1",
          name: "L'Homme Lancôme",

          testCoverage: 95,

          tests: [
            {
              input: "What are the notes in L'Homme Lancôme?",
              expected:
                "L'Homme Lancôme features notes of cardamom, lavender, cedar, and vetiver, creating a sophisticated, masculine fragrance.",
              received:
                "L'Homme Lancôme features notes of cardamom, lavender, cedar, and vetiver, creating a sophisticated, masculine fragrance.",
              success: true,
              id: "ac8283f9-67fa-4599-ab8a-bacb45337f42",
            },
            {
              input: "When should I wear L'Homme Lancôme?",
              expected:
                "L'Homme Lancôme is perfect for professional settings and everyday wear, offering a classic, refined masculine scent.",
              received:
                "L'Homme Lancôme is perfect for professional settings and everyday wear, offering a classic, refined masculine scent.",
              success: true,
              id: "9d5e6495-f06f-4e0e-844f-b3b8e2f93300",
            },
          ],
        },
        {
          id: "1cc4cc45-07b4-4e16-9d1a-1b76ba57deed",
          name: "Hypnôse Homme",
          testCoverage: 85,

          tests: [
            {
              input: "What makes Hypnôse Homme seductive?",
              expected:
                "Hypnôse Homme features notes of lavender, cardamom, and tonka bean, creating a mysterious, seductive masculine fragrance.",
              received:
                "Hypnôse Homme features notes of lavender, cardamom, and tonka bean, creating a mysterious, seductive masculine fragrance.",
              success: true,
              id: "8b6fb38e-d5c1-458a-ab33-68b1935ae301",
            },
            {
              input: "Who should wear Hypnôse Homme?",
              expected:
                "Hypnôse Homme is perfect for confident men who want to make a memorable impression with its hypnotic, sophisticated scent.",
              received:
                "Hypnôse Homme is perfect for confident men who want to make a memorable impression with its hypnotic, sophisticated scent.",
              success: true,
              id: "6dec42c4-a12d-4903-9e8b-0acd0e55fe7a",
            },
          ],
        },
        {
          id: "1f78e509-3b7a-41ed-afac-dee533fbd851",
          name: "Miracle Homme",
          testCoverage: 80,

          tests: [
            {
              input: "What does Miracle Homme represent?",
              expected:
                "Miracle Homme represents modern masculinity with fresh, citrus notes combined with warm, woody undertones for a contemporary scent.",
              received:
                "Miracle Homme represents modern masculinity with fresh, citrus notes combined with warm, woody undertones for a contemporary scent.",
              success: true,
              id: "fe5d859e-b265-4751-ade2-66e60df8185c",
            },
            {
              input: "What occasions is Miracle Homme suitable for?",
              expected:
                "Miracle Homme is suitable for both casual and formal occasions, offering versatility with its fresh yet sophisticated character.",
              received:
                "Miracle Homme is suitable for both casual and formal occasions, offering versatility with its fresh yet sophisticated character.",
              success: true,
              id: "b74f9208-8656-4ed3-9c2a-40ae2db9d252",
            },
          ],
        },
      ],
    },
  ],
};
